module.exports = __webpack_public_path__ + "static/media/GF-logo-bg.ff152966.svg";